<template>
  <div class="text-field" :class="{'text-field--pushed-label': labelPushed}">
    <div class="text-field__control">
      <label
        class="text-field__label"
        :class="{'has-text-danger': error}"
        :for="name">
        {{label}}
      </label>
      <textarea
        @blur="$emit('blur', $event)"
        :name="name"
        :id="name"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @focusin="active = true"
        @focusout="active = false"
        v-bind="$attrs"
      >
      </textarea>
    </div>
    <span class="text-field__error has-text-danger" v-if="error">
      {{error}}
    </span>
  </div>
</template>

<script>
  export default {
    name: 'TextArea',
    props: {
      name: String,
      label: String,
      error: String,
      value: String,
    },
    data() {
      return {
        active: false,
      };
    },
    computed: {
      labelPushed() {
        return this.active || this.value;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../assets/styles/variables";

  .text-field {
    padding: 12px 0;
    width: 392px;
    @media(max-width: 996px) {
      width: 100%;
    }
    .text-field__control {
      position: relative;
      height: 100%;
    }

    .text-field__label {
      position: absolute;
      top: 16%;
      left: 0;
      z-index: 1;
      font-size: 14px;
      color: $text-body;
      padding: 4px 16px;
      transform: translateY(-50%);
      transition: all 0.2s;
      font-weight: 500;
      pointer-events: none;
    }

    textarea {
      width: 100%;
      height: 100%;
      border-radius: 16px;
      box-shadow: none;
      padding: 22px 13px 8px;
      font-size: 14px;
      line-height: 14px;
      border: 1px solid transparent;
      transition: all 0.5s;
      font-family: 'Roboto';
      outline: none;

      &::placeholder {
        color: $text-body;
      }

      &:focus {
        border-color: $primary-main;

        @include shadow-4;
      }

      &:disabled {
        background-color: $background-4;
        color: $text-body;
      }
    }

    &.text-field--pushed-label {
      .text-field__label {
        top: 12px;
        font-size: 12px;
      }

      input {
        padding-top: 16px;
      }
    }

    .text-field__error {
      position: relative;
      font-size: 14px;
      width: 21%;
      padding-left: 16px;
      display: table-cell;
    }
  }
</style>
